import React from "react";
// UI Framework
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { TableCell } from "@mui/material";
import { toast } from "react-toastify";
// Common Components
import { Loading, Modal } from "src/Components";
// Local Components
import AddEditStrategyModal from "./AddEditStrategyModal";
// Services
import { deleteStrategy } from "src/Requests/deltaHedgeAccounts";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import { IAdditional } from "src/Tables/TableTemplate/tableTemplate";
import type { StrategyReport } from "src/Interfaces/deltaHedgeAccounts";

const AdditionalHeader: React.FC = () => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">ویرایش</span>
      </TableCell>
      <TableCell>
        <span className="!font-black text-black">حذف</span>
      </TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: StrategyReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [loading, setLoading] = React.useState(false);
  const [isEditOpen, setIsEditOpen] = React.useState(false);

  const cancelHandler = () => {
    setLoading(true);
    deleteStrategy(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const editHandler = () => {
    setIsEditOpen(true);
  };

  return (
    <>
      {isEditOpen ? (
        <Modal
          title="ویرایش استراتژی"
          onClose={() => setIsEditOpen(false)}
          UI={
            <AddEditStrategyModal
              editValues={{ ...row }}
              onClose={() => setIsEditOpen(false)}
              onSuccess={onAction}
            />
          }
          modalBoxClassName="!min-w-min"
        />
      ) : (
        <></>
      )}
      <TableCell>
        <div
          className="hover:bg-slate-300 transition-all rounded p-1"
          onClick={editHandler}
        >
          <EditIcon className="text-sky-700 cursor-pointer" />
        </div>
      </TableCell>
      <TableCell>
        <div onClick={cancelHandler}>
          {loading ? (
            <Loading size={16} className="!text-slate-700" />
          ) : (
            <DeleteIcon className="!text-red-700" />
          )}
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<StrategyReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
